import { render } from "./BaseFlex.vue?vue&type=template&id=077de18c&scoped=true&ts=true"
import script from "./BaseFlex.vue?vue&type=script&lang=ts"
export * from "./BaseFlex.vue?vue&type=script&lang=ts"

import "./BaseFlex.vue?vue&type=style&index=0&id=077de18c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077de18c"]])

export default __exports__